import React, { useEffect, useState } from 'react';
import bunnyLogoDark from '~/images/bunnynet-dark.svg';
import bunnyLogoLight from '~/images/bunnynet-light.svg';
import NavHeader from './menu/menu-header';
import NavHeaderMobile from './menu/menu-header-mobile';
import { getCookie, setCookie } from '../utils/cookie-handler';
import { useMenuState } from '../utils/menu-state-provider';
import { THEMES, GRID_BREAKPOINTS } from '~/utils/constants';
import { useContainerDimensions } from '~/hooks/container-dimensions';

const TopBanner = ({ data }) => {
  const [isHidden, setIsHidden] = useState(
    data.enabled === false || Number(getCookie('bn_topbanner')) === 1
  );

  function clickHandler() {
    setCookie('bn_topbanner', 1, 1);
    setIsHidden(true);
  }

  if (isHidden) {
    return null;
  }

  return (
    <div className='top-banner-wr'>
      <div className='content'>
        <div
          className='text'
          dangerouslySetInnerHTML={{ __html: data.text }}
        ></div>
        <a
          className='cta'
          href={data.cta_url}
        >
          {data.cta_text}
        </a>
      </div>
      <div
        className='close'
        onClick={clickHandler}
      >
        x
      </div>
    </div>
  );
};

const Header = props => {
  const navRef = React.useRef(null);
  const [isOpen, setIsOpen] = useState(false);
  const [desktopHeaderData, setDesktopHeaderData] = useState(null);
  const [mobileHeaderData, setMobileHeaderData] = useState(null);
  const [error, setError] = useState(null);
  const { setMenuState } = useMenuState();
  const { width } = useContainerDimensions(navRef);
  // Set the logo based on the header color, default to dark
  // if the header color is not set.
  // Additionally set the logo based on the menu state.
  // If the menu is open, set the logo to the dark version, because
  // the mobile light overlay is not yet implemented.
  const [logo, setLogo] = useState(
    props.header_color === THEMES.LIGHT_BLUE ? 'dark' : 'light'
  );
  let hideHeaderMenu = false;
  let showHeaderMenuItems = true;

  const toggleLogo = () => {
    if (props.header_color === THEMES.LIGHT_BLUE) {
      setLogo(isOpen ? 'dark' : 'light');
    }
  };

  const handleToggle = () => {
    setIsOpen(!isOpen);
    setMenuState(!isOpen);
    toggleLogo();
  };

  useEffect(() => {
    if (width > GRID_BREAKPOINTS.md) {
      setIsOpen(false);
      setMenuState(false);
      if (props.header_color === THEMES.LIGHT_BLUE) {
        setLogo('dark');
      }
    }
  }, [width]);

  const loadHeaderMenu = async (menuName, type) => {
    try {
      const fallbackModule = await import(`~/data/menu/${menuName}.json`, {
        assert: { type: 'json' },
      });
      if (type === 'desktop') {
        setDesktopHeaderData(fallbackModule.default);
      } else {
        setMobileHeaderData(fallbackModule.default);
      }
    } catch (fallbackErr) {
      console.error('Failed to load fallback menu.', fallbackErr);
      setError(fallbackErr.message);
    }
  };

  useEffect(() => {
    if (!props.header_menu) {
      loadHeaderMenu('menu_header', 'desktop');
    }
  }, [props.header_menu]);

  useEffect(() => {
    if (!props.mobile_menu) {
      loadHeaderMenu('menu_header_mobile', 'mobile');
    }
  }, [props.mobile_menu]);

  if (error) return <p>Error loading JSON: {error}</p>;

  if (props.hides) {
    hideHeaderMenu = props.hides.header_menu === true;
    showHeaderMenuItems = props.hides.header_menu_items !== true;
  }

  if (hideHeaderMenu) {
    return null;
  }

  return (
    <>
      <TopBanner data={props.top_banner} />
      <header className='site-header'>
        <div className='container'>
          <nav
            ref={navRef}
            role='navigation'
          >
            <a
              className={`logo ${showHeaderMenuItems ? '' : 'py-4 lg:py-0'}`}
              href='/'
            >
              <img
                src={bunnyLogoDark}
                alt={props.siteTitle}
                title={props.siteTitle}
                className={logo === 'dark' ? 'block' : 'hidden'}
              />
              {/* Changing logo based on SRC is too slow */}
              <img
                src={bunnyLogoLight}
                alt={props.siteTitle}
                title={props.siteTitle}
                className={logo === 'light' ? 'block' : 'hidden'}
              />
            </a>
            <NavHeader
              show_items={showHeaderMenuItems}
              menu_src_override={props.menu_src_override}
              location={props.location}
              menu_data={props.header_menu || desktopHeaderData}
            />

            {showHeaderMenuItems && (
              <div
                id='menu-toggle'
                className={`menu-toggle ${isOpen ? 'is-open' : ''}`}
                onClick={handleToggle}
              >
                <div className='menu-inner'></div>
              </div>
            )}
          </nav>
        </div>
      </header>

      {showHeaderMenuItems && (
        <div className='nav-mobile-wr'>
          <NavHeaderMobile
            location={props.location}
            menu_data={props.mobile_menu || mobileHeaderData}
            handleToggle={handleToggle}
          />
        </div>
      )}
    </>
  );
};

export default Header;
